module.exports = __webpack_public_path__ + "static/media/dots.0b12e778.svg";